<template>
  <mescroll-vue class="mescroll" :class="{'mescroll1':isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp"
                @init="mescrollInit">
    <div ref="wrap">
      <div class="cateBox white">
        <van-grid :column-num="5" :border="false">
          <van-grid-item v-for="(item, i) in cate2List" :key="i" :icon="item.icon" :text="item.name"
                         @click="$router.push('/union/tao/taoCate2List?cate2Id='+item.pid+'&cate2Name='+item.name)">
            <img slot="icon" :src="item.icon" alt="" style="width: 100%">
              <div slot="text" class="f12">{{item.name}}</div>
          </van-grid-item>
        </van-grid>
      </div>
      <!--排序Bar-->
      <sortBar :sortType="sortType" @bindSort="changeSort"></sortBar>
      <div class="white ">
        <div class="list" id="listId">
          <div v-for="(item, i) in dataList" :key="i" class="white">
            <goodsItem :item="item" layoutType="0" source="ALI">
            </goodsItem>
          </div>
        </div>
      </div>
    </div>
  </mescroll-vue>
</template>

<script>
import {taoCate2List, taoListByCate1} from "../../../api/commonV2";

export default {
  name: 'cate',
  props: {
    cateId: 0, //淘宝一级分类id
  },
  data() {
    return {
      sortType: 0, //排序
      cate2List: [], //二级分类
      dataList: [], //分类商品列表
    }
  },
  created() {
    this.getCate2List()
  },
  methods: {
    // 上拉加载
    upCallback(val) {
      let data = {
        pageNo: val.num,
        pageSize: val.size,
        cateId: this.cateId,
        sortType: this.sortType
      }

      if (val.num === 1) {
        this.dataList = []
      }
      taoListByCate1(data).then(res => {
        if (res.result === '0') {
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
        } else {
          this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
        }
      }, err => {
        this.mescroll.endErr()
      })
    },
    // 切换排序规则
    changeSort(val) {
      switch (val) {
        case 0:
          this.sortType = 0
          break
        case 1:
          this.sortType === 1 ? this.sortType = 2 : this.sortType = 1
          break
        case 2:
          this.sortType === 3 ? this.sortType = 4 : this.sortType = 3
          break
        case 3:
          this.sortType === 5 ? this.sortType = 6 : this.sortType = 5
          break
      }
      this.$nextTick(
        function () {
          this.mescroll.resetUpScroll()
        }
      )
    },
    getCate2List() {
      let data = {
        cateId: this.cateId
      }
      taoCate2List(data).then(res => {
        if (res.result === '0') {
          this.cate2List = res.dataList
        }
      }, err => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/tabBar/home/cate.vue